import Vue from 'vue'
import axios from 'axios'
import Logan from 'logan-web';

// 发送请求前配置请求及参数
axios.interceptors.request.use((config) => {
  var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'))
  var token = (arr != null) ? unescape(arr[2]) : null
  config.url += `${config.url.includes('?') ? '&' : '?'}_token=${token}`
  /*if(config.method  === 'post') {
    // 上传到七牛时如果在参数中添加login_token会报错
    if (config.url == 'http://upload.qiniu.com') return config

    if (!config.data) config.data = {}
    config.data._token = token
  }*/
  return config
},(error) =>{
  return Promise.reject(error)
})

axios.interceptors.response.use((res) => {
  try {
    let urlStr = res.config.url
    if ((~urlStr.indexOf('im.itaojin.cn') || urlStr.charAt(0) == '/' && urlStr.charAt(1) != '/') && !~urlStr.indexOf('CustomerStatusApi.heartbeat') && !~urlStr.indexOf('CustomerStatusApi.getCustomerServiceStat') && !~urlStr.indexOf('/QxJiKeApi.') || ~urlStr.indexOf('tjkOperation/tjkStatusMap/query')) {
      Logan.log(JSON.stringify(res), 2);
    }
  } catch(e){
    Logan.log('存储请求日志失败', 2);
  }

  if (res.config.url.includes('returnData=')) {
    return res.data
  } else if (res.data.result && res.data.result.error == 'token_empty') {
    // _token 错误
    res.data.status = false;
    res.data.msg = '会话失效，请重新登录';
  } else {
    if (res.data.result && res.data.result.error) {
      res.data.status = false;
      res.data.msg = res.data.result.error_description;
    } else if (res.data.status === false || res.data.status === true) {
      if (res.data.message) res.data.msg = res.data.message;
    } else {
      res.data.status = true;
      if (res.data.result) res.data.data = res.data.result;
    }
  }

  return res.data
},(error) =>{
  let code = error.response ? error.response.status : '';

  return Promise.reject(code)
})

Vue.prototype.$axios = axios


// WEBPACK FOOTER //
// ./src/config/axios.js